import React from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';
import {useTheme} from '@mui/material';

export default function AddressGroupIcon(props: SvgIconProps): JSX.Element {
    const defaultColor = useTheme().palette.primary.dark;
    const color = props.htmlColor || defaultColor;
    return (
        <SvgIcon
            {...props}
            htmlColor={color}
            width={16}
            height={78}
            viewBox="0 0 16 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            titleAccess="address entry group"
            sx={{
                height: '78px',
                width: '16px',
            }}>
            <circle cx={8} cy={6} r={5} stroke="#636A6D" strokeWidth={2} fill="#FFFFFF"/>
            <circle cx={8} cy={22} r={2} fill="#D9D9D9"/>
            <circle cx={8} cy={32} r={2} fill="#D9D9D9"/>
            <circle cx={8} cy={42} r={2} fill="#D9D9D9"/>
            <circle cx={8} cy={52} r={2} fill="#D9D9D9"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14.065 68.2605C14.065 70.7292 12.5751 73.1063 11.1684 74.8145C10.314 75.852 9.36254 76.8487 8.31297 77.6938C8.13005 77.8408 7.86952 77.8408 7.6866 77.6938C6.6326 76.8445 5.69061 75.858 4.83122 74.8145C3.42445 73.1063 1.93457 70.7292 1.93457 68.2605C1.93457 64.804 4.54326 62.1953 7.99979 62.1953C11.479 62.1953 14.065 65.2251 14.065 68.2605ZM10.6665 67.9997C10.6665 66.6663 9.52373 65.333 7.9998 65.333C6.47586 65.333 5.33313 66.4757 5.33313 67.9997C5.33313 69.5236 6.47586 70.6663 7.9998 70.6663C9.52373 70.6663 10.6665 69.5236 10.6665 67.9997Z" fill="#D52043"/>
        </SvgIcon>
    );
}